import { IPaginationRequest } from "interfaces/pagination";
import axios from "axios";

const cobraServiceService = axios.create({
  baseURL: `${process.env.REACT_APP_API}/cobra/service`,
});

const CobraServiceServices = {
  getDetail: (token: string, id: string) =>
    cobraServiceService.get(`/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  getAll: (token: string, pagination: IPaginationRequest) =>
    cobraServiceService.get(
      `/list?perPage=${pagination.per_page}&page=${pagination.page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
  getClubFittingAll: (token: string) =>
    cobraServiceService.get("/club-fitting/all", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  create: (
    token: string,
    data: {
      name: string;
      duration: number;
      sequence: number;
    }
  ) =>
    cobraServiceService.post("", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  edit: (
    token: string,
    id: string | number,
    data: {
      name: string;
      duration: number;
      sequence: number;
    }
  ) =>
    cobraServiceService.put(`/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  delete: (token: string, id: string | number) =>
    cobraServiceService.delete(`/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
};

export default CobraServiceServices;
